const OSS = require('ali-oss');
// import OSS from 'ali-oss'
import api from '@/util/api'
import {
  Toast
} from 'vant'
import {
  compressImage
} from './compressImage'
import {
  base64
} from 'js-md5';

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
}

function uploadfile(client, file, type) {
  return new Promise((resolve, reject) => {
    const storeAs = 'upload-file_' + (file.lastModified || Math.random()) + ".png";
    client.multipartUpload(storeAs, file).then((res) => {
      resolve(res.name)
    })
  })
}
async function upload(files, type) {
  var urls = []
  var res = await api.common.getPrivateSecurityToken();
  const creds = res.data
  const client = new OSS({
    region: 'oss-cn-shanghai',
    accessKeyId: creds[0],
    accessKeySecret: creds[1],
    stsToken: creds[2],
    bucket: type
  })
  Toast.loading({
    message: '上传中...',
    forbidClick: true,
    duration: 0
  })
  for (var i = 0; i < files.length; i++) {
    if (type == 'pri-twonet') {
      var item = await base64Img(files[i])
      var url = await uploadfile(client, item, type)
    }
    urls.push(url)
  }
  Toast.clear()
  return urls
}
async function uploadImg(files) {
  return upload(files, 'pri-twonet')
}
async function base64Img(files) {
  let config = {
    width: 3000, // 压缩后图片的宽
    height: 2000, // 压缩后图片的高
    quality: 1 // 压缩后图片的清晰度，取值0-1，值越小，所绘制出的图像越模糊
  }
  let resultImg = await compressImage(files, config)
  return resultImg
}


export default {
  uploadImg: uploadImg,
  toBlob: dataURLtoBlob
}
